import swordsmithPayment from '../assets/finance/swordsmith-payment.webp';

/** Illustration originale entière. La découpe animée déformait la bourse ;
 * Arnaud préfère explicitement cette image fixe à une animation défectueuse. */
export function ForgeExchangeScene(): React.JSX.Element {
  return (
    <div className="forge-exchange" aria-hidden="true">
      <img className="forge-exchange__still" src={swordsmithPayment} alt="" />
    </div>
  );
}
